export const validationSearch = value => {
  return value[0] === ' ' ? true : /[\\(\\)#$\\^*+\\[\]\\|\\?]/.test(value);
};

export const validationNumber = value =>
  /[a-zA-Z_~`\\(\\)!#@$%\\^&*+=\-\\[\]\\';,.\\/{}|\\":<>\\?]/.test(value);

export const validationNumberAndLetters = value =>
  /[a-zA-Z_~`\\\w\s\\1234567890(\\)!#@$%\\^&*+=\-\\[\]\\';,.\\/{}|\\":<>\\?]/.test(
    value
  );

// Blocks dots by design. The FF "Feature Name" field uses validationFeatureFlagName
// below (FF keys are dotted); don't add '.' here — it feeds several other fields. P81-104298
export const validationNoSpecialCharacters = (inputValue, maxLength) => {
  if (
    ((maxLength ? inputValue.length < maxLength + 1 : true) &&
      !inputValue.replace(/[a-zA-Z0-9-_\s]/gi, '') &&
      `${inputValue.slice(0, 1)}` !== ' ') ||
    inputValue === ''
  ) {
    return true;
  } else {
    return false;
  }
};

// FF "Feature Name" field only — allows dots because FF keys are dotted
// (ffKey.ip.role.management). Do NOT reuse elsewhere; see P81-104298.
export const validationFeatureFlagName = (inputValue, maxLength) => {
  if (
    ((maxLength ? inputValue.length < maxLength + 1 : true) &&
      !inputValue.replace(/[a-zA-Z0-9-_.\s]/gi, '') &&
      `${inputValue.slice(0, 1)}` !== ' ') ||
    inputValue === ''
  ) {
    return true;
  } else {
    return false;
  }
};

// Mirrors the backend FF key build (feature.service.js, P81-104298): true when the
// name still has content after dropping a leading "ffkey." and trimming spaces/dots.
// Keeps the "Add New Feature" CTA disabled for content-less names like "ffKey.".
export const hasFeatureFlagNameContent = name =>
  name
    .toLowerCase()
    .replace(/^ffkey\./, '')
    .split(/[\s.]+/)
    .filter(Boolean).length > 0;

export const validateUUID = uuidStr => {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuidStr);
};
